import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';
import PageWrapper from 'components/ui/PageWrapper';
import { FilledButton, Checkbox } from '@ds/react-components';
import {
  setUserTcPreference,
  getUserTcPreference,
} from 'utils/userPreferences';
import TcContent from './TcContent';

import * as Styled from './TermsAndConditions.styled';

const TermsAndConditions = (props) => {
  const { hasAcceptedTC, updateTcAccepted, userId } = props;

  const history = useHistory();

  const [tcReadStatus, setTcReadStatus] = useState({
    tcReadComplete: false,
    tcCheckboxChecked: false,
  });

  const onClickDismiss = () => {
    history.push('/Logout');
  };

  const onClickAccept = () => {
    updateTcAccepted(true);
    setUserTcPreference(userId); //The server update is not immediate. So storing locally as well.
  };

  const onTcCheckboxChange = () => {
    setTcReadStatus((prevState) => ({
      ...prevState,
      tcCheckboxChecked: !prevState.tcCheckboxChecked,
    }));
  };

  const scrolledToEnd = useCallback(() => {
    setTcReadStatus((prevState) => ({
      ...prevState,
      tcReadComplete: true,
    }));
  }, [setTcReadStatus]);

  const onModalScroll = useCallback(
    (event) =>
      event.target.offsetHeight + event.target.scrollTop >=
        event.target.scrollHeight - 10 && scrolledToEnd(),
    [scrolledToEnd]
  );

  //If the user has already accepted the terms and condition then do not show the accept option again.
  if (hasAcceptedTC || getUserTcPreference(userId)) {
    return (
      <PageWrapper>
        <Styled.PageContainer>
          <Styled.TermsTitle>{'Terms and Conditions'}</Styled.TermsTitle>
          <Styled.NonModalPaper>
            <Styled.NonModalHeaderContainer>
              <Styled.TermsModalTitle>
                {'Debitsuccess Website Terms and Conditions'}
              </Styled.TermsModalTitle>
            </Styled.NonModalHeaderContainer>
            <Styled.NonModalBodyContainer>
              <TcContent />
              <Styled.NonModalCheckboxContainer>
                <Checkbox
                  checked={true}
                  variant="primary"
                  disabled={true}
                  label={
                    'I have read and understand the above terms and conditions'
                  }
                />
              </Styled.NonModalCheckboxContainer>
            </Styled.NonModalBodyContainer>
          </Styled.NonModalPaper>
        </Styled.PageContainer>
      </PageWrapper>
    );
  }

  return (
    <Dialog open={true} scroll="paper" maxWidth={'md'} onScroll={onModalScroll}>
      <Styled.ModalHeaderContainer disableTypography={true}>
        <Styled.TermsModalTitle>
          {'Debitsuccess Terms and Conditions'}
        </Styled.TermsModalTitle>
      </Styled.ModalHeaderContainer>
      <Styled.ModalBodyContainer>
        <TcContent />
      </Styled.ModalBodyContainer>
      <Styled.ModalActionsContainer>
        <Styled.ModalActionsWrapper>
          <Checkbox
            checked={tcReadStatus.tcCheckboxChecked}
            variant="primary"
            disabled={!tcReadStatus.tcReadComplete}
            onChange={onTcCheckboxChange}
            label={'I have read and understand the above terms and conditions'}
          />
          <Styled.ActionButtonsContainer>
            <FilledButton variant="error" onClick={onClickDismiss}>
              {'Decline'}
            </FilledButton>
            <Styled.AcceptButton
              variant="success"
              onClick={onClickAccept}
              disabled={!tcReadStatus.tcCheckboxChecked}>
              {'Accept'}
            </Styled.AcceptButton>
          </Styled.ActionButtonsContainer>
        </Styled.ModalActionsWrapper>
      </Styled.ModalActionsContainer>
    </Dialog>
  );
};

TermsAndConditions.propTypes = {
  hasAcceptedTC: PropTypes.bool,
  updateTcAccepted: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
};

TermsAndConditions.defaultProps = {
  hasAcceptedTC: false,
};

export default TermsAndConditions;
